import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { TCustomer } from '../types';

const initialState: TCustomer & { isVerified: boolean, hasCurrentOrder: boolean } = {
    isVerified: false,
    hasCurrentOrder: false,
    phoneNumber: '',
    name: ''
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        changeUsername: (state, action: PayloadAction<string>) => {
            state.name = action.payload
        },
        setUserId: (state, action: PayloadAction<string>) => {
            state._id = action.payload
        },
        changePhoneNumber: (state, action: PayloadAction<string>) => {
            state.phoneNumber = action.payload
        },
        changeUserVerification: (state, action: PayloadAction<boolean>) => {
            state.isVerified = action.payload
        },
        setUserFromServer: (state, action: PayloadAction<TCustomer>) => {
            state._id = action.payload._id
            state.phoneNumber = action.payload.phoneNumber
            state.name = action.payload.name
            state.preferedLocale = action.payload.preferedLocale
            state.isVerified = true
        },
        setHasCurrentOrder: (state, action: PayloadAction<boolean>) => {
            state.hasCurrentOrder = action.payload
        },
        setLocale:  (state, action: PayloadAction<string>) => {
            state.preferedLocale = action.payload
        },
    }
})

export default userSlice;